module.exports = __webpack_public_path__ + "static/media/new-view-icon.74b61f1b.svg";